import api from '@/services/api'

/**
 * 检查 APP 版本更新
 * @param {String} platform 平台 (ANDROID/IOS)
 * @param {Number} currentVersion 当前版本号
 */
export function checkAppVersion(platform, currentVersion) {
  return api.get('/app-version/check', {
    params: { platform, currentVersion }
  })
}
